//firebase.js
import firebase from "firebase/compat/app"
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyALHDuBjFOzc3q9WU0VcEx572kCKE84HMY",
    authDomain: "colors-82cc6.firebaseapp.com",
    databaseURL: "https://colors-82cc6-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "colors-82cc6",
    storageBucket: "colors-82cc6.appspot.com",
    messagingSenderId: "8688795097",
    appId: "1:8688795097:web:fcf73b065bbce40c512dc8",
    measurementId: "G-ETVD2VZ9PB"
};

// firebaseConfig 정보로 firebase 시작
firebase.initializeApp(firebaseConfig);

// firebase의 firestore 인스턴스를 변수에 저장
const firestore = firebase.firestore();

// 필요한 곳에서 사용할 수 있도록 내보내기
export { firestore };